import { render } from "./AffectationCaisseModalPage.vue?vue&type=template&id=1cafe2e8&ts=true"
import script from "./AffectationCaisseModalPage.vue?vue&type=script&lang=ts"
export * from "./AffectationCaisseModalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__